import React from "react";
import { NavLink } from "react-router-dom";
import {
  OrderIcon,
  NotificationIcon,
  ManageCategoryIcon,
  ManagepProductsIcon,
  ManageUsersIcon,
  ManageAgentsIcon,
  ManageVendorsIcon,
  ManagePaymentsIcon,
  ReportsIcon,
  SettingsIcon,
  HomeIcon,
  HelpIcon,
  ContactIcon,
} from "../SvgIcons";
import { constants } from "../../utils/constants";

const Agent = () => {
  return (
    <div className="d-flex flex-column flex-shrink-0 h-100 sideBar">
      <ul className="nav nav-pills sidebarNav flex-column mb-auto">
        {/* <li className="nav-item">
          <NavLink
            to="/mange-user"
            className="nav-link"
            activeClassName="active"
          >
            <HomeIcon />
            Home
          </NavLink>
        </li> */}
        <li className="nav-item">
          <NavLink
            to="/manage-user"
            className="nav-link"
            activeClassName="active"
          >
            <ManageUsersIcon />
            User Management
          </NavLink>
        </li>

        {/* <li className="nav-item">
          <NavLink
            to="/manage-officer"
            className="nav-link"
            activeClassName="active"
          >
            <ManageUsersIcon />
            Officer Management
          </NavLink>
        </li> */}

        <li className="nav-item">
          <NavLink
            to="/manage-agents"
            className="nav-link"
            activeClassName="active"
          >
            <ManageUsersIcon />
            Agent Management
          </NavLink>
        </li>
        {/* <li className="nav-item">
          <NavLink
            to="/manage-representatives"
            className="nav-link"
            activeClassName="active"
          >
            <ManageUsersIcon />
            Representatives Management
          </NavLink>
        </li> */}
        <li className="nav-item">
          <NavLink
            to="/notifications"
            className="nav-link"
            activeClassName="active"
          >
            <NotificationIcon />
            Notifications
          </NavLink>
        </li>
        {/* <li className="nav-item">
          <NavLink
            to={"/page-list/"}
            className="nav-link"
            activeClassName="active"
          >
            <SettingsIcon />
            Pages
          </NavLink>
        </li> */}
      </ul>
    </div>
  );
};

export default Agent;
